import { graphql } from '~/__gql__';

export const mutationRequestGoldPlanOffer = graphql(/* GraphQL */ `
  mutation RequestGoldPlanOffer {
    requestGoldPlanOffer
  }
`);
